<template>
  <div>
    <div class="action-lists">
      <div class="left-btns">
        <div class="" @click="showOther('plan')">推广计划</div>
        <div class="selected">推广组</div>
        <div class="" @click="showOther('adv')">创意</div>
      </div>
      <!-- <div class="right-action">
        <div class="" title="添加计划组" @click="add()"><img src="../../../assets/images/add-icon.png" alt="添加计划组"></div>
        <div class="" title="启用计划组" @click="changeStatus(1)"><img src="../../../assets/images/start-icon.png" alt="启用计划组"></div>
        <div class="" title="暂停计划组" @click="changeStatus(0)"><img src="../../../assets/images/stop-icon.png" alt="暂停计划组"></div>
        <div class="" title="删除计划组" @click="del()"><img src="../../../assets/images/del-icon.png" alt="删除计划组"></div>
        <el-input placeholder="搜索相关内容" v-model="keyword" class="input-with-select" style="width: 200px; margin-right: 20px;">
            <el-button slot="append" icon="el-icon-search" @click="search()"></el-button>
          </el-input>
      </div> -->
    </div>
    <div class="table">
      <div class="btns">
        <el-button type="primary" icon="fa fa-plus-circle" @click="add()"> 新建推广组</el-button>
        <div class="make">
          <el-button size="small" @click="changeStatus(1)">开启</el-button>
          <el-button size="small" @click="changeStatus(0)">暂停</el-button>
          <el-button size="small" @click="del()">删除</el-button>
        </div>
      </div>
      <el-table ref="multipleTable" border :data="tableData" tooltip-effect="dark" style="width: 100%" @select="selectRow" @select-all="selectAll">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column prop="title" label="推广计划"></el-table-column>
          <el-table-column prop="group_name" label="推广组名称" show-overflow-tooltip></el-table-column>
          <el-table-column label="投放状态" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-switch v-model="scope.row.status" @change="changeStatusOne(scope.$index)"></el-switch>
            </template>
          </el-table-column>
          <el-table-column label="投放位置">
            <template>新华社</template>
          </el-table-column>
          <el-table-column prop="price" label="出价"></el-table-column>
          <el-table-column label="操作" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-button size="mini" @click="edit(scope.$index)">编辑</el-button>
              <el-button type="danger" size="mini" @click="delOne(scope.row.group_id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
    </div>
    <div class="page-c">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10, 20, 30, 40, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageTotal">
      </el-pagination>
    </div>

    <el-dialog :title="title" :visible.sync="dialogFormVisible" width="560px">
      <el-form ref="form" :model="form" :rules="rules" label-width="140px">
        <el-form-item label="所属推广计划名称" prop="plan_id">
          <el-select v-model="form.plan_id" placeholder="请选择计划" style="width: 320px;">
            <el-option :label="item.title" :value="item.plan_id" v-for="(item, index) in planLists" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="计划组名称" prop="group_name">
          <el-input v-model="form.group_name" style="width: 320px;"></el-input>
        </el-form-item>
        <el-form-item label="媒体类型">
            <el-select v-model="form.media_type" placeholder="" style="width: 240px;">
                <el-option label="默认" value="1"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="出价" prop="price">
          <el-input v-model="form.price" placeholder="最低出价为0.60元" style="width: 160px;"></el-input>
          <span style="margin-left: 10px;">元/点击 参考出价：[0.8-2.0]</span>
        </el-form-item>
        <el-form-item label="状态" prop="status">
            <el-select v-model="form.status" placeholder="" style="width: 240px;">
                <el-option label="启用" value="1"></el-option>
                <el-option label="暂停" value="0"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="投放位置">
            <el-checkbox v-model="form.position">新华网</el-checkbox>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: center;">
        <el-button size="small" @click="dialogFormVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="submitForm('form')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// @ is an alias to /src
export default {
  name: 'index',
  data() {
    return {
      keyword: '',
      title: '添加推广组',
      dialogFormVisible: false,
      tableData: [],
      form: {
        group_id: '',
        plan_id: '',
        group_name: '',
        price: '',
        media_type: '1',
        status: '1',
        position: true
      },
      rules: {
        group_name: [
          { required: true, message: '请输入推广组名称', trigger: 'blur' },
          { min: 0, max: 30, message: '长度不能超过30个字符', trigger: 'blur' }
        ],
        plan_id: [
          { required: true, message: '请选择推广组', trigger: 'change' }
        ],
        price: [
          { min: '0.6', required: true, message: '最低出价为0.6', trigger: 'blur' }
        ]
      },
      planLists: [],
      type: 'add',
      page: 1,
      pageSize: 10,
      pageTotal: 1,
      loading: true,
      ids: []
    };
  },
  created() {
    this.$http.post('/trader/index/group_form', {
      group_id: this.form.group_id
    }).then(res => {
      if (res.code === 200) {
        this.planLists = res.data.plan_lists;
        this.getData();
      }
    });
  },
  methods: {
    getData() {
      this.$http.post('/trader/index/getGroupPlanLists', {
        keyword: this.keyword,
        page: this.page,
        pageSize: this.pageSize
      }).then(res => {
        if (res.code === 200) {
          this.tableData = res.data;
          this.pageTotal = Math.ceil(res.count / this.pageSize);
          this.$function.hiddenLoading();
        }
      });
    },
    search() {
      this.page = 1;
      this.getData();
    },
    add() {
      this.dialogFormVisible = true;
      this.type = 'add';
      this.title = '添加推广组';
    },
    edit(index) {
      this.type = 'edit';
      this.title = '编辑推广组';
      this.form = {
        group_id: this.tableData[index].group_id,
        plan_id: this.tableData[index].plan_id,
        group_name: this.tableData[index].group_name,
        price: this.tableData[index].price,
        media_type: '1',
        status: this.tableData[index].status ? '1' : '0',
        position: true
      };
      this.dialogFormVisible = true;
    },
    selectRow(sel, row) {
      const selected = sel.length && sel.indexOf(row) !== -1;
      if (selected) {
        if (this.ids.indexOf(row.group_id) === -1) {
          this.ids.push(row.group_id);
        }
      } else {
        if (this.ids.indexOf(row.group_id) !== -1) {
          this.ids.splice(this.ids.indexOf(row.group_id), 1);
        }
      }
    },
    selectAll(sel) {
      if (sel.length > 0) {
        this.ids = [];
        for (var i = 0; i < sel.length; i++) {
          this.ids.push(sel[i].group_id);
        }
      } else {
        this.ids = [];
      }
    },
    changeStatusOne(index) {
      this.ids.push(this.tableData[index].group_id);
      this.changeStatus(this.tableData[index].status ? 1 : 0);
    },
    changeStatus(val) {
      if (this.ids.length) {
        this.$http.post('/trader/index/changeGroupPlanStatus', {
          ids: this.ids.join(','),
          value: val
        }).then(res => {
          if (res.code === 200) {
            this.getData();
            this.ids = [];
            this.$message.success('操作成功，仅审核通过的创意可修改状态');
          } else {
            this.$message.error('操作失败');
          }
        });
      }
    },
    delOne(id) {
      this.ids.push(id);
      this.del();
    },
    del() {
      if (this.ids.length) {
        this.$http.post('/trader/index/delGroupPlan', {
          ids: this.ids.join(',')
        }).then(res => {
          if (res.code === 200) {
            this.getData();
            this.ids = [];
            this.$message.success('操作成功');
          } else {
            this.$message.error('操作失败');
          }
        });
      }
    },
    showOther(type) {
      this.$emit('showOther', type);
    },
    handleSizeChange(value) {
      this.page = 1;
      this.pageSize = value;
      this.getData();
    },
    handleCurrentChange(page) {
      this.page = page;
      this.getData();
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const url = this.type === 'add' ? '/trader/index/createGroupPlan' : '/trader/index/saveGroupPlan';
          this.$http.post(url, this.form).then(res => {
            if (res.code === 200) {
              this.page = 1;
              this.getData();
              this.dialogFormVisible = false;
              this.$message.success('操作成功');
              this.form = {
                group_id: '',
                plan_id: '',
                group_name: '',
                price: '',
                media_type: '1',
                status: 1,
                position: true
              };
            } else {
              this.$message.error(res.msg);
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  }
};
</script>

<style lang="less" scoped="">
  .action-lists {
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: 50px;
    background: #F7F8F8;
    .display {
      display: flex;
      align-items: center;
      height: 50px;
    }
    .left-btns {
      .display;
      div {
        width: 140px;
        height: 100%;
        line-height: 50px;
        text-align: center;
        color: #0056AF;
        cursor: pointer;
      }
      .selected {
        color: #166D9F;
        background: #fff;
      }
    }
    .right-action {
      .display;
      div {
        width: 34px;
        height: 34px;
        margin-left: 20px;
        cursor: pointer;
      }
    }
  }
  .table {
    width: calc(100% - 40px);
    padding: 20px;
    .make {
      padding: 20px 0;
    }
  }
  .page-c {
    background: #fff;
    padding: 20px;
  }
  img {
    width: 100%;
    height: 100%;
  }
</style>
